import { Routes, Route } from "react-router-dom";
import HomePage from "../../pages/home/HomePage";
import Noticias from "../../pages/noticias/noticias";
import NoticiaDetalhe from "../../pages/noticias/components/noticiaDetalhe";
import TransparencyPage from "../../pages/TransparencyPage";
import AccessibilityPage from "../../pages/AccessibilityPage";
import MesaDiretora from "../../pages/MesaDiretora";
import Institucional from "../../pages/Institucional";
import MapaDoSite from "../../pages/mapaDoSite";
import Vereadores from "../../pages/vereadores/vereadores";
import TodosVereadores from "../../pages/vereadores/components/components/todosvereadores";
import VereadorDetalhes from "../../pages/vereadores/components/vereadorDetalhes";
import FaleConosco from "../../pages/FaleConosco";
import DetalhesPublicacao from "../../pages/home/components/components/detalhesPublicacao";
import Publicacoes from "../../pages/publicacoes/Publicacoes"
import TermosPrivacidade from "../../pages/TermodePrivacidade";

import NotFound from "../../pages/NotFound";

import { RouteLogin } from "./RouteLogin";
import { PrivateRoute } from "./PrivateRoute";

import Login from "../../pages/admin/Login/login";
import DashboardAdmin from "../../pages/admin/dashboard admin/Dashboard";
import NewsAdmin from "../../pages/admin/news admin/News";
import UsersAdmin from "../../pages/admin/users admin/users";
import PublicationsAdmin from "../../pages/admin/publications admin/Publications";
import EditUserAdmin from "../../pages/admin/users admin/edit";
import CreateUserAdmin from "../../pages/admin/users admin/creat";
import CreateNewsAdmin from "../../pages/admin/news admin/Creat";
import EditNewsAdmin from "../../pages/admin/news admin/Edit";
import CategoriesAdmin from "../../pages/admin/publications admin/category/categories";
import CreateCategory from "../../pages/admin/publications admin/category/Creat";
import EditCategory from "../../pages/admin/publications admin/category/Edit";
import CreatePost from "../../pages/admin/publications admin/Creat";
import EditPublication from "../../pages/admin/publications admin/Edit";
import AdminCategories from "../../pages/admin/news admin/category/categories";
import CreateCategoryNews from "../../pages/admin/news admin/category/Creat";
import EditCategoryNews from "../../pages/admin/news admin/category/Edit"
import SearchResults from "../../pages/dashboard/components/components/SearchResults";

import Dashboard from "../../pages/dashboard/Dashboard";
const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />}>
        <Route path="" element={<HomePage />} />
        <Route path="/transparency" element={<TransparencyPage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="/mesaDiretora" element={<MesaDiretora />} />
        <Route path="/institucional" element={<Institucional />} />
        <Route path="/mapadosite" element={<MapaDoSite />} />
        <Route path="/vereadores:nome" element={<Vereadores />} />
        <Route path="/vereadores/:nome" element={<VereadorDetalhes />} />
        <Route path="/todosvereadores" element={<TodosVereadores />} />
        <Route path="/noticias" element={<Noticias />} />
        <Route path="/noticia/:id" element={<NoticiaDetalhe />} />
        <Route path="/faleconosco" element={<FaleConosco />} />
        <Route path="/detalhes" element={<DetalhesPublicacao />} />
        <Route path="/*" element={<NotFound />} />
        <Route path="/publicacoes/:categoria" element={<Publicacoes/>} />
        <Route path="/TermosPrivacidade" element={<TermosPrivacidade/>} />
        <Route path="/search-results" element={<SearchResults/>} />
      </Route>
      <Route
        path="/login"
        element={
          <RouteLogin>
            <Login />
          </RouteLogin>
        }
      />

      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <DashboardAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/news"
        element={
          <PrivateRoute>
            {" "}
            <NewsAdmin />{" "}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <PrivateRoute>
            <UsersAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/publications"
        element={
          <PrivateRoute>
            <PublicationsAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/editUser/:userId"
        element={
          <PrivateRoute>
            <EditUserAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/createuser"
        element={
          <PrivateRoute>
            <CreateUserAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/creatnews"
        element={
          <PrivateRoute>
            <CreateNewsAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/editnews/:newsId"
        element={
          <PrivateRoute>
            <EditNewsAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/categories"
        element={
          <PrivateRoute>
            <CategoriesAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/createcategory"
        element={
          <PrivateRoute>
            <CreateCategory />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/editcategory/:catId"
        element={
          <PrivateRoute>
            <EditCategory />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/creatpubli"
        element={
          <PrivateRoute>
            <CreatePost />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/edipublication/:id"
        element={
          <PrivateRoute>
            <EditPublication />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/categoriesNews"
        element={
          <PrivateRoute>
            <AdminCategories />
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/createcategorynews"
        element={
          <PrivateRoute>
            <CreateCategoryNews />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/editcategornews/:id"
        element={
          <PrivateRoute>
            <EditCategoryNews />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
